import { ReactNode } from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import WarningIcon from '@mui/icons-material/WarningTwoTone';
import { getResponsiveFontSize } from 'theme/watchdutyTheme.utils';
import { openNativeAppSettings } from 'shared/utils';

type NoPermissionAccessProps = {
  title: string;
  description: string | ReactNode;
  buttonTitle: string;
};

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: 'max(env(safe-area-inset-bottom), 16px)',
    overflowY: 'auto',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
  },
  icon: {
    fontSize: getResponsiveFontSize('8rem'),
  },
  description: {
    '& > :first-child': {
      marginBottom: theme.spacing(3),
    },
  },
}));

export const NoPermissionAccess = (
  props: NoPermissionAccessProps,
): JSX.Element => {
  const { title, description, buttonTitle } = props;
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Container maxWidth="md" className={classes.container}>
        <Stack spacing={2}>
          <Box className={classes.iconContainer}>
            <WarningIcon color="error" className={classes.icon} />
          </Box>

          <Typography variant="h1" align="center">
            {title}
          </Typography>

          {typeof description === 'string' ? (
            <Typography>{description}</Typography>
          ) : (
            <Box className={classes.description}>{description}</Box>
          )}

          <Button fullWidth size="large" onClick={openNativeAppSettings}>
            {buttonTitle}
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};
